import { render } from "./DepartmentFilter.vue?vue&type=template&id=7f2a0ce8"
import script from "./DepartmentFilter.vue?vue&type=script&lang=js"
export * from "./DepartmentFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__